<template>
  <div class="col-12 col-md-6 my-3 position-relative message-container cursor-pointer"
       :class="[
           { 'align-self-start' : !isSender },
           { 'align-self-end' : isSender },
           { 'selected' : isSelected },
       ]">
    <div class="d-flex m-0" :class="{ 'justify-content-end' : isSender }">
      <div class="col-1 d-flex align-self-stretch" :class="{ 'order-2  justify-content-end': isSender }">
        <AvatarBadge class="mt-auto" :avatar-url="message.from?.avatar && message.from?.avatar_url" :fullname="message.from?.fullname"  />
      </div>
      <div
          class="min-w-75px mw-lg-400px align-content-center position-relative"
          :class="[
              { 'send' : isSender },
              { 'receive' : !isSender },
          ]"
      >
        <div style="white-space: pre-line !important;" class="fw-bold" v-if="message.type === 'TEXT'" >
          <div v-if="isEditing">
             <textarea
                 v-model="editFormData.content"
                 :placeholder="$t('chat.writeMessage')"
                 class="form-control" rows="1"
                 @keypress.enter="editMessage"
             ></textarea>
            <div class="d-flex mt-2">
              <button
                  class="btn btn-sm btn-primary me-2"
                  :disabled="!message.content || message.content.toString().trim() === editFormData.content.toString().trim()"
                  @click.prevent="editMessage"> Enregister </button>
              <button
                  class="btn btn-sm btn-danger"
                  @click.prevent="cancelEdit"> Annuler </button>
            </div>
          </div>
          <span v-else>
            {{ message.content }}
          </span>
        </div>
        <span v-if="message.type === 'FILE'" >
          <a
              v-for="(file, index) in message.content.split(',')"
              :key="index"
              @click.prevent="download(getFileUrl(index, message?.file_urls))"
              :href="getFileUrl(index, message?.file_urls)" download target="_blank">
            <div class="mb-2 message_file position-relative">
              <img v-if="isPicture(file)" :src="getFileUrl(index, message?.file_urls)" :alt="file">
              <span v-else class="d-flex align-items-center p-5 ">
                <i class="fa fa-file-alt fa-3x me-4 text-primary"></i>
                {{ file }}
              </span>
              <span class="file-download-icon ">
                  <i class="fa fa-download"></i>
               </span>
            </div>
          </a>
        </span>
        <audio v-if="message?.type === 'AUDIO'" ref="fmAudio" controls />
        <div class="position-absolute text-muted bottom-0 end-0 mb-n7" :class="[{ 'end-0': isSender }, { 'start-0': !isSender }]">
          <span class="me-2" v-if="!isSender">{{ getDateHour(message?.created_at) }}</span>
          <em style="font-size: .9em"  v-if="message.modified"  :title="$dateFormatter(message.updated_at, locale, true)"> <i style="font-size: .9em" class="fa fa-pen"></i> Modifié</em>
          <span v-if="isSender" class="ms-2">{{ getDateHour(message?.created_at) }}</span>
          <!--          <i v-if="message?.read" class="fa fa-check-double text-primary ms-2"></i>
                    <i v-else-if="!message?.read" class="fa fa-check-double ms-2"></i>
                    <i v-else-if="message?.send" class="bi bi-check2 ms-2"></i>-->
        </div>
      </div>
    </div>
    <div class="share-btn position-absolute top-50 translate-middle cursor-pointer"
       :class="[
        { 'me-n7 end-0 ' : !isSender },
        { 'ms-n7' : isSender }
        ]">
      <MessageActions
          :conversation-id="message.conversation_id"
          :message-id="message.id"
          :share="share"
          :isMe="isSender"
          :canEdit="message?.type === 'TEXT'"
          :edit="toggleEditMsgForm"
      />
    </div>
  </div>
</template>

<script setup>

import AvatarBadge from "@/components/AvatarBadge.vue";
import Plyr from "plyr";

import {ref, onMounted, onUnmounted, computed} from "vue"
import {useLocales} from "@/composables/locales";
import MessageActions from "@/Modules/Chat/components/MessageActions.vue";
import {useStore} from "vuex";
import {$dateFormatter} from "@/mixins/Helpers";

const { locale } = useLocales()

const store = useStore()
const props = defineProps({
  message: {
    type: Object,
    required: true
  },
  isSelected: { type: Boolean, default: false },
  share: Function,
})

const now = ref(new Date())
const fmAudio = ref(null)
const player = ref(null)
const interval = ref(null)
const isEditing = ref(false)
const processEditing = ref(false)
const editFormData = ref({
  content: ''
})

const isSender = computed(() => !!props.message?.is_me)

onMounted(() => {

  if(props.message?.type === 'AUDIO') {
    player.value = new Plyr(fmAudio.value, {
      speed: {
        selected: 1,
        options: [0.5, 1, 1.5],
      },
    });

    setSource(0)

    player.value.on('play', () => {
    });
  }



  interval.value = setInterval(() => {
    now.value = new Date()
  }, 1000)
})

onUnmounted(() => {
  if(interval.value) {
    clearInterval(interval.value)
  }
})

function getDateHour(date) {
  return new Date(date).toLocaleTimeString(locale.value, {
    hour: '2-digit',
    minute: '2-digit'
  })
}
async function setSource(index) {
  const token = Ls.get('auth.token');

  try {
    const audioBlobUrl = await loadAudioWithAuth(props.message?.content, token);
    player.value.source = {
      type: 'audio',
      sources: [
        {
          src: audioBlobUrl,
          type: `audio/ogg`,
        },
      ],
    };
  } catch (error) {
    console.error("Erreur lors du chargement de l'audio", error);
  }
}
async function loadAudioWithAuth(url, token) {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error('Erreur lors du téléchargement de l’audio');

    const blob = await response.blob();
    return URL.createObjectURL(blob); // Retourne l'URL du fichier Blob
  } catch (error) {
    throw new Error('Erreur réseau ou autre: ' + error.message);
  }
}

function isPicture(url = '') {
  const exts = ['png', 'jpg', 'jpeg']
  const match = url.split('?')[0].split('.').pop().toLowerCase()
  return exts.includes(match)
}

function getFileUrl(fileIndex, urls = []) {
  if(urls.length) {
    return urls[fileIndex]
  }
  return ''
}

function toggleEditMsgForm() {
  editFormData.value.content = props.message.content
  isEditing.value = true
}

function cancelEdit() {
  isEditing.value = false
}

function editMessage(e){
  processEditing.value = true
  if(e.shiftKey === false){
    e.preventDefault()
    store.dispatch('chat/editMessage', {
      content: editFormData.value.content,
      id: props.message.id
    }).then(res => {
      editFormData.value.content = ''
      isEditing.value = false
    }).catch(err => {

    }).finally(() => processEditing.value = false)
  }
}

function download(url) {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = url.split('/').pop();
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

</script>

<style lang="scss">
//@import 'plyr/src/sass/plyr.scss';

.send {
  padding: 15px;
  border-radius: 10px 10px 0 10px;
  background-color: #0072CE0D;
  min-height: 15px;
}

.receive {
  padding: 15px;
  border-radius: 10px 10px 10px 0;
  background-color: #F7F7F7;
  min-height: 15px;
}

.message_file {
  position: relative;
  width: 100%;
  max-width: 100%;
  max-height: 250px;
}
.file-download-icon {
  display: none!important;
  background-color: var(--bs-gray-200);

}
.message_file:hover .file-download-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  display: block !important;
}
.message_file > img {
  height: 250px;
  max-height: 250px;
}
.message_file img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  -o-object-fit: contain;
  object-position: center;
  -o-object-position: center;
}

.share-btn {
  display: none;
}

.message-container:active, .message-container.selected {
  background-color: var(--bs-light-primary);
}

.message-container.selected .share-btn {
  display: block;
}

.share-sender-rotate {
  transform: rotateY(180deg);
}


</style>